import classNames from "classnames";
import { Typography } from "PFComponents/typography";
import { getWeekdaysMin } from "PFCore/helpers/date";

import css from "./week_days_select.module.scss";

type WeekdayProps = {
  readonly?: boolean;
  weekDayNumber: number;
  onClick: (day: number) => void;
  selected: boolean;
  disabled: boolean;
};

export const Weekday = ({ readonly, disabled, weekDayNumber, onClick, selected }: WeekdayProps) => {
  const weekdays = getWeekdaysMin();

  return (
    <button
      type="button"
      disabled={disabled || readonly}
      className={classNames(css.day, {
        [css.selected]: selected,
        [css.disabled]: disabled,
        [css.readonly]: readonly
      })}
      onClick={() => onClick(weekDayNumber)}
    >
      <Typography variant="bodyBold">{weekdays[weekDayNumber]}</Typography>
    </button>
  );
};
